
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { NextPage } from 'next'
import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'
import { ToastContainer } from 'react-toastify'

import AddPhoneNumberForm from '@/components/forms/AddPhoneNumberForm'
import ChangePasswordForm from '@/components/forms/ChangePasswordForm'
import BaseLayout from '@/components/layouts/BaseLayout'
import ContentWrapper from '@/components/ui/ContentWrapper'
import InfoPopup from '@/components/ui/Popups/InfoPopup'
import Caption from '@/components/ui/Typo/Caption'
import Subtitle from '@/components/ui/Typo/Subtitle'
import { NAMESPACE_SETTINGS_PAGE } from '@/res/namespaces'

const SettingsPage: NextPage = () => {
  const { t } = useTranslation(NAMESPACE_SETTINGS_PAGE)
  const router = useRouter()

  const showInfoPopup = router.query.show_info == 'true'

  const onClose = () => {
    const queries = { ...router.query }
    delete queries['show_info']
    router.replace({
      pathname: router.pathname,
      query: queries,
    })
  }

  return (
    <BaseLayout seoTitle={t('seo_title')} seoDescription={t('seo_description')}>
      {showInfoPopup && <InfoPopup onClose={onClose} text={t('info_text')} />}
      <ContentWrapper>
        <ToastContainer />
        <div className="mb-40 small:px-10">
          <div className="text-center mb-10">
            <Subtitle className="mt-4" weight="font-medium">
              {t('settings')}
            </Subtitle>
            <Caption color="text-gray3" className="">
              {t('settings_description')}
            </Caption>
          </div>
          <ChangePasswordForm />
          <AddPhoneNumberForm />
        </div>
      </ContentWrapper>
    </BaseLayout>
  )
}

export default SettingsPage


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/settings',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  